"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCachedCollectionConstructor = createCachedCollectionConstructor;
/**
 * Cached collection stores sole models, that declared in hateoas-models.
 * Standard method returns optional result
 *
 * @param Model - instance of hateoasModelFactory
 */
function createCachedCollectionConstructor(Model) {
    var CachedCollection = Model.Collection.extend({
        initialize: function initialize() {
            this.add({ id: -1 }); // work around for `subsetOf('...')`
        },
        get: function get(modelId) {
            var model = CachedCollection.__super__.get.apply(this, arguments);
            if (model) {
                return model;
            }

            var ModelConstructor = this.model;
            var newModel = new ModelConstructor({ id: modelId });
            this.add(newModel);
            newModel.fetch();

            return newModel;
        },


        /**
         * Standard get method of nestedTypes
         */
        getIfPresent: function getIfPresent() {
            return CachedCollection.__super__.get.apply(this, arguments);
        }
    });

    return CachedCollection;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/cache/cachedCollectionFactory.js
// module id = 1412
// module chunks = 118